import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { t } from '../../../../../modules/infra/i18n';

const NotesModal = ({ isOpen, onRequestClose, client }) => {
  if (!client) return null;

  const { customer, appointmentNote, customerNote } = client;
  const customerName = `${customer.firstName} ${customer.lastName}`;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={{
        base: 'waitlist-settings-modal',
        afterOpen: 'waitlist-settings-modal--open',
        beforeClose: 'waitlist-settings-modal--closing',
      }}
      overlayClassName={{
        base: 'waitlist-settings-overlay',
        afterOpen: 'waitlist-settings-overlay--open',
        beforeClose: 'waitlist-settings-overlay--closing',
      }}
      ariaHideApp={false}
      contentLabel={t('appointment:walk_in_list.notes.modal_content_label')}
      shouldCloseOnOverlayClick
    >
      <div className="waitlist-settings-panel">
        <div className="waitlist-settings-header">
          <h2>{t('appointment:walk_in_list.notes.modal_title', { customerName })}</h2>
          <button
            className="waitlist-settings-close"
            onClick={onRequestClose}
            aria-label={t('appointment:walk_in_list.notes.close_aria_label')}
          >
            ×
          </button>
        </div>
        <div className="waitlist-settings-section">
          {customerNote && (
            <div style={{ marginBottom: '20px' }}>
              <div className="waitlist-settings-section-label">
                {t('appointment:walk_in_list.notes.customer_notes_section')}
              </div>
              <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px', whiteSpace: 'pre-wrap' }}>
                {customerNote}
              </div>
            </div>
          )}
          {appointmentNote && (
            <div style={{ marginBottom: '20px' }}>
              <div className="waitlist-settings-section-label">
                {t('appointment:walk_in_list.notes.appointment_notes_section')}
              </div>
              <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px', whiteSpace: 'pre-wrap' }}>
                {appointmentNote}
              </div>
            </div>
          )}
          {!customerNote && !appointmentNote && (
            <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
              {t('appointment:walk_in_list.notes.no_notes')}
            </div>
          )}
        </div>
      </div>
    </ReactModal>
  );
};

NotesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  client: PropTypes.shape({
    customer: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    }).isRequired,
    appointmentNote: PropTypes.string,
    customerNote: PropTypes.string,
  }),
};

export default NotesModal;
